<template>
  <div class="WarrantySearch">
    <div class="form-title">
      <span class="icon"></span>
      <span>{{ $i18n.t('search1') }}</span>
      <span class="f12"> ({{ $i18n.t('search2') }}) </span>
    </div>
    <div class="form-main">
      <el-input
        type="textarea"
        v-model="searchValue"
        :placeholder="$i18n.t('search3')"
      ></el-input>
      <el-button @click="searchData">{{ $i18n.t('submitBtn') }}</el-button>
      <p>{{ $i18n.t('search4') }}</p>
      <p v-html="$i18n.t('search5')">
      </p>
      <p class="mt20">
        {{ $i18n.t('search6') }}
        <a :href="url[lang] || 'https://en.aiswei-tech.com/intro/Customer-Interaction-Center-3.html'" target="_blank">{{ $i18n.t('search7') }}</a> {{ $i18n.t('search8') }}
      </p>
    </div>
    <div class="table">
      <div class="form-title">
        <span class="icon"></span>
        <span>{{ $i18n.t('search9') }}</span>
      </div>

      <data-table :columnDatas="columnDatas" :tableData="tableData">
      </data-table>
      <p class="mt20" style="margin-bottom: 100px;" v-if="showDownload">
         {{ $i18n.t('search10') }}
        </p>
    </div>
  </div>
</template>

<script>
import { searchCodeApi, getPath } from "../../../deps/api";

export default {
  created() {
    this.url = {
      polish: 'https://solplanet.net/pl/kontakt/',
      de: 'https://solplanet.net/de/contact-us/'
    }
    this.lang = this.$i18n.locale
  },
  computed: {},
  data() {
    return {
      showDownload: false,
      searchValue: "",
      tableData: [],
      columnDatas: {
        noSum: true,
        showIndex: false,
        showSelect: false,
        columns: [
          {
            label: this.$i18n.t('number'),
            key: '',
            width: 50,
            render: (h, params) => {
              return h('span', params.index + 1)
            }
          },
          {
            label: this.$i18n.t('serialNumber'),
            prop: "isn",
            width: 170,
            type: "text",
          },
          {
            label: this.$i18n.t('search11'),
            prop: "standardWarrantyPeriod",
            width: 190,
            type: "text",
          },
          {
            label: this.$i18n.t('search12'),
            prop: "extendWarrantyPeriod",
            width: 190,
            type: "text",
          },
          {
            label: this.$i18n.t('startWarrantyDate'),
            render: (h, params) => {
              return h(
                "div",
                params.row.startWarrantyDate
                  ? params.row.startWarrantyDate.split('T')[0]
                  : ""
              );
            },
            type: "text",
          },
          {
            label: this.$i18n.t('endWarrantyDate'),
            render: (h, params) => {
              return h(
                "div",
                params.row.endWarrantyDate
                  ? params.row.endWarrantyDate.split('T')[0]
                  : ""
              );
            },
            type: "text",
          },
          {
            label: this.$i18n.t('search14'),
            align: 'center',
            width: 130,
            render: (h, params) => {
              return h(
                "el-button",
                {
                  on: {
                    click: () => {
                      this.download(params.row.isn);
                    },
                  },
                  props: {
                    type: "primary",
                  },
                },
                this.$i18n.t('download')
              );
            },
            type: "text",
          }
        ],
      },
    };
  },
  methods: {
    download(isn) {
      if (!window.isLogin) {
        this.$openWaring();
        return;
      }
      getPath({isn: isn}).then(res => {
        window.open(res.message);
      })
    },
    searchData() {
      this.tableData = [];
      let searchCodes = this.searchValue
        .split(/[\s\n\\,]/)
        .filter((i) => i !== "");
      if (!searchCodes.length) {
        this.$message.warning(this.$i18n.t('search13'));
        return;
      }
      searchCodeApi(searchCodes).then((res) => {
        this.$message.success(this.$i18n.t('success'));
        this.tableData = res.data;
      });
    },
  },
};
</script>

<style lang="stylus">
.WarrantySearch {
  padding-left: 50px;

  .form-title {
    .icon {
      width: 10px;
      height: 10px;
      background: linear-gradient(270deg, #AB499E 0%, #FF4F4F 100%);
      border-radius: 2px;
      display: inline-block;
      transform: rotate(45deg);
      margin-right: 4px;
    }

    span {
      font-size: 18px;
      color: #3E3E3E;
    }

    .f12 {
      font-size: 14px;
      color: #717171;
    }
  }

  .form-main {
    padding-top: 30px;
    width: 542px;
    text-align: center;

    .el-textarea {
      textarea {
        width: 542px;
        min-height: 135px !important;
        background: #FAFAFA;
      }
    }

    .el-button {
      width: 280px;
      height: 48px;
      background: linear-gradient(270deg, #AB499E 0%, #FF4F4F 100%);
      border-radius: 34px;
      padding: 0;
      color: #fff;
      font-size: 24px;
      border: 0;
      margin-top: 60px;
      margin-bottom: 30px;
    }

    p {
      font-size: 14px;
      color: #A2A0A5;
      text-align: left;

      &.mt20 {
        margin-top: 20px;
      }

      a {
        color: #108ee9;
      }
    }
  }

  .table {
    width: 1100px;
    margin-left: -408px;

    .form-title {
      padding: 50px 0 30px;
    }

    .main-table {
      padding: 0;
      margin-bottom: 0px !important ;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/homePages/routes/WarrantySearch.vue